import { CartLinkedEntitlementsSchema, CartProductSchema, ProductStatus } from '../../types';

export const isEntitlementChanged = (
  selectedEntity: Partial<CartProductSchema> | Partial<CartLinkedEntitlementsSchema>
) => {
  return selectedEntity?.productStatuses && selectedEntity?.productStatuses?.indexOf(ProductStatus.EDITED) > -1;
};
